import "./App.css";
import logo from "./assets/logo.jpeg";
import lobby from "./assets/lobby.jpg";
// images
import clean from "./assets/clean.jpg";
import garden from "./assets/garden.jpg";
import instel from "./assets/instel.jpg";
import electricity from "./assets/electricity.jpg";
import camera from "./assets/camera.jpg";
import pestcontrol from "./assets/pestcontrol.jpg";
import polish from "./assets/polish.jpg";
import accountant from "./assets/accountant.jpg";
import emailjs from "emailjs-com";
import { useEffect, useState } from "react";

function App() {
  const [visible, setVisible] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [scrolled, setScrolled] = useState(false)
  const [accessOpen, setAccessOpen] = useState(false);
  const [fontSize, setFontSize] = useState(1);
  const [highContrast, setHighContrast] = useState(false);;
  const [form, setForm] = useState({
  name: "",
  phone: "",
  message: "",
}); 

const handleSubmitMail = (e) => {
  e.preventDefault();

  emailjs.send(
    "service_joj8wve",      // Service ID שלך
    "template_0rk8kso",     // Template ID שלך
    {
      name: form.name,
      phone: form.phone,
      message: form.message,
    },
    "jsB7c4ZtvFpFzEGBW" // תכף נסביר מה זה
  )
  .then(() => {
    alert("נשלח בהצלחה!");
    setForm({ name: "", phone: "", message: "" });
  })
  .catch((error) => {
    console.log(error);
    alert("שגיאה בשליחה");
  });
};

  useEffect(() => {
    setVisible(true);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  

  const services = [
    { title: "ניהול בניינים חכם", image: accountant, desc: "שליטה מלאה על הבניין: גבייה, ספקים, תחזוקה ותפעול ללא כאבי ראש לדיירים." },
    { title: "ניקיון ברמה גבוהה", image: clean, desc: "שמירה על לובי וחדרי מדרגות נקיים 24/7 ברמה של בניין יוקרה." },
    { title: "גינון ותחזוקת חוץ", image: garden, desc: "גינות מטופחות שמעלות את ערך הנכס ונותנות תחושת יוקרה." },
    { title: "אינסטלציה מהירה", image: instel, desc: "טיפול מיידי בכל תקלה בצנרת, נזילות ובעיות מים." },
    { title: "מערכות חשמל", image: electricity, desc: "פתרונות חשמל מקצועיים, בטוחים ומהירים לכל תקלה." },
    { title: "אבטחה ומצלמות", image: camera, desc: "התקנת מצלמות ומערכות אבטחה מתקדמות לשקט נפשי מלא." },
    { title: "הדברה מקצועית", image: pestcontrol, desc: "פתרון יסודי למזיקים ושמירה על סביבה נקייה ובריאה." },
    { title: "פוליש וחידוש מבנים", image: polish, desc: "הפיכת הלובי וחדרי המדרגות למראה יוקרתי ונוצץ." },
  ];


  return (
    <div
      style={{
        ...styles.page,
        fontSize: `${fontSize}em`,
        filter: highContrast ? "contrast(1.4)" : "none",
        background: highContrast ? "#000" : styles.page.background,
        color: highContrast ? "#fff" : "black",
        transition: "0.3s",
      }}
    >
      {/* NAVBAR */}
      {/* NAVBAR */}
      <div
        style={{
          ...styles.navbar,
          background: scrolled ? "rgba(0,0,0,0.6)" : "transparent",
          backdropFilter: scrolled ? "blur(10px)" : "none",
          boxShadow: scrolled ? "0 5px 20px rgba(0,0,0,0.3)" : "none",
        }}
      >
        <img src={logo} alt="GROUP 148" style={styles.logo} />

        {/* אם זה לא מובייל → תפריט רגיל */}
        {!isMobile && (
          <div style={styles.navLinks}>
            <a href="#services" style={{ ...styles.navLink, color: scrolled ? "white" : "black" }}>
              שירותים
            </a>

            <a href="#about" style={{ ...styles.navLink, color: scrolled ? "white" : "black" }}>
              אודות
            </a>

            <a href="#contact" style={{ ...styles.navLink, color: scrolled ? "white" : "black" }}>
              צור קשר
            </a>
          </div>
        )}

        {/* אם מובייל → המבורגר */}
        {isMobile && (
          <div
            style={{
              ...styles.hamburger,
              color: scrolled ? "white" : "black",
              transition: "0.3s",
            }}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </div>
        )}
      </div>

      {/* תפריט נפתח במובייל */}
      {isMobile && menuOpen && (
        <div style={styles.mobileMenu}>
          <a
            href="#services"
            style={{ ...styles.mobileLink, color: "white" }}
            onClick={() => setMenuOpen(false)}
          >
            שירותים
          </a>

          <a
            href="#about"
            style={{ ...styles.mobileLink, color: "white" }}
            onClick={() => setMenuOpen(false)}
          >
            אודות
          </a>

          <a
            href="#contact"
            style={{ ...styles.mobileLink, color: "white" }}
            onClick={() => setMenuOpen(false)}
          >
            צור קשר
          </a>
        </div>
      )}

      {/* HERO */}
      <div style={styles.hero}>
        <div style={styles.overlay}></div>

        <div
          style={{
            ...styles.heroContent,
            opacity: visible ? 1 : 0,
            transition: "1s",
          }}
        >
          <img src={logo} alt="GROUP 148" style={styles.heroLogo} />

          <h1 style={styles.title}>GROUP 148</h1>

          <button
            style={styles.heroButton}
            onClick={() => window.open("https://wa.me/972543226298")}
          >
            קבלו הצעת מחיר עכשיו
          </button>
        </div>
      </div>

      {/* SERVICES */}
      <div id="services" style={styles.services}>
        <h2 style={styles.sectionTitle}>מה אנחנו עושים בשבילך</h2>

        <div style={styles.grid}>
          {services.map((service, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                ...styles.card,
                transform: hoveredIndex === index ? "scale(1.05)" : "scale(1)",
                border: hoveredIndex === index ? "6px solid white" : "2px solid transparent",
                boxShadow:
                  hoveredIndex === index
                    ? "0 15px 30px rgba(0,0,0,0.35)"
                    : "0 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <div
                style={{
                  ...styles.cardBg,
                  backgroundImage: `url(${service.image})`,
                  filter: hoveredIndex === index ? "brightness(0.3)" : "brightness(1)",
                }}
              ></div>

              <div style={styles.cardOverlay}>
                <h3>{service.title}</h3>

                {/* 👇 זה השינוי החשוב */}
                <p
                  style={{
                    ...styles.cardDesc,
                    opacity: hoveredIndex === index ? 1 : 0,
                    transform: hoveredIndex === index ? "translateY(0)" : "translateY(10px)",
                    transition: "0.3s",
                  }}
                >
                  {service.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ABOUT */}
      <div id="about" style={styles.about}>
        <h2 style={styles.sectionTitle}>GROUP 148</h2>

        <p style={styles.aboutText}>
          אנחנו לא עוד חברת אחזקה — אנחנו דואגים שהבניין שלך יתפקד ברמה של מלון יוקרה בלי התעסקות מצדך
        </p>

        <p style={styles.aboutText}>
          שירות מהיר, צוות מקצועי וזמינות מלאה 24/7 לכל תקלה
        </p>

        <p style={styles.aboutText}>
          המטרה שלנו: להפוך כל בניין למקום נקי, מתוחזק ויוקרתי לאורך זמן
        </p>
      </div>

      {/* CONTACT */}
      <div id="contact" style={styles.contact}>
        <h2 style={styles.sectionTitle}>?רוצה שננהל לך את הבניין</h2>

        <form style={styles.form} onSubmit={handleSubmitMail}>
          <input
            type="text"
            placeholder="שם מלא"
            style={styles.input}
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />

          <input
            type="text"
            placeholder="טלפון"
            style={styles.input}
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
          />

          <textarea
            placeholder="?מה אתה צריך"
            style={styles.textarea}
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
          />
          השארת פרטים מהווה הסכמה ליצירת קשר בלבד. המידע לא יועבר לצד שלישי
          <button style={styles.submitButton}>שלח</button>
        </form>
      </div>

      {/* WHATSAPP */}
      <a
        href="https://wa.me/972543226298"
        target="_blank"
        rel="noreferrer"
        style={styles.whatsapp}
      >
        ליצירת קשר       </a>

      {/* FOOTER */}
      {/* FOOTER */}
      <footer style={styles.footer}>

        <div style={styles.footerGrid}>

          {/* לוגו + תיאור */}
          <div style={styles.footerBox}>
            <img src={logo} alt="GROUP 148" style={styles.footerLogo} />
            <p>ניהול מבנים ברמה אחרת</p>
            <p style={{ fontSize: "12px", opacity: 0.7 }}>
              © 2026 GROUP 148 - כל הזכויות שמורות
            </p>
          </div>

          {/* שירותים */}
          <div style={styles.footerBox}>
            <h4>שירותים</h4>
            <p>ניהול בניינים</p>
            <p>ניקיון ותחזוקה</p>
            <p>אבטחה ומצלמות</p>
            <p>אינסטלציה וחשמל</p>
          </div>

          {/* יצירת קשר */}
          <div style={styles.footerBox}>
            <h4>צור קשר</h4>
            <p>📞 054-3226298</p>
            <p>info@group148.com</p>
            <p>💬 WhatsApp זמין 24/7</p>
            <p>📍 ישראל</p>
          </div>

        </div>

        <div style={styles.footerBottom}>
          <p>האתר משמש לצורכי מידע בלבד</p>
          <p>הצהרת נגישות פעילה באתר</p>
          <div style={styles.management}>
            <p>CEO: Daniel Levy</p>
            <p>COO: Mor Levy</p>

          </div>

        </div>

      </footer>
      <button
        onClick={() => setAccessOpen(!accessOpen)}
        style={styles.accessButton}
      >
        ♿
      </button>
      {accessOpen && (
        <div style={styles.accessPanel}>
          <h3>נגישות</h3>

          <button onClick={() => setFontSize(fontSize + 0.1)}>
            הגדל טקסט
          </button>

          <button onClick={() => setFontSize(fontSize - 0.1)}>
            הקטן טקסט
          </button>

          <button onClick={() => setHighContrast(!highContrast)}>
            מצב ניגודיות גבוהה
          </button>

          <button onClick={() => setFontSize(1)}>
            איפוס
          </button>
        </div>
      )}
    </div>
  );
}

/* styles נשאר אותו דבר */
const styles = {
  page: {
    fontFamily: "Arial",
    background: "#f5f5f5",
    paddingTop: "80px", // 👈 חשוב!
  },
  navbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center", // 👈 חשוב
    padding: "15px 20px",
    background: "#111",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1000,
    transition: "0.3s ease",

  },

  logo: { height: "60px" },

  navLinks: {
    display: "flex", gap: "15px",
  },
  navLink: {
    textDecoration: "none",
    fontSize: "18px",
    fontWeight: "500",
    position: "relative",
    padding: "5px 0",
    transition: "0.3s",
  },

  hero: {
    position: "relative",
    height: "90vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundImage: `url(${lobby})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    textAlign: "center",
  },

  overlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
  },

  heroContent: {
    position: "relative",
    color: "white",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",   // 👈 מרכז אופקית
    justifyContent: "center", // 👈 מרכז אנכית
    gap: "15px", // 👈 ריווח בין האלמנטים
  },

  heroButton: {
    padding: "12px 25px",
    background: "linear-gradient(135deg, #ffffff, #dcdcdc)",
    color: "#000",
    border: "none",
    borderRadius: "30px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
  },

  title: { fontSize: "42px" },

  services: {
    padding: "60px 15px",
    background: "#808080",
    textAlign: "center",
  },

  sectionTitle: {
    fontSize: "26px",
    marginBottom: "30px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "15px",
    maxWidth: "1200px",
    margin: "0 auto",
  },

  card: {
    position: "relative",
    height: "230px",
    borderRadius: "10px",
    overflow: "hidden",
    cursor: "pointer",
    transition: "0.3s",
  },

  cardBg: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },

  cardOverlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.4)",
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
  },

  cardDesc: {
    fontSize: "13px",
    marginTop: "8px",
  },

  about: {
    padding: "60px 15px",
    background: "white",
    textAlign: "center",
  },

  aboutText: {
    maxWidth: "800px",
    margin: "15px auto",
    fontSize: "16px",
    lineHeight: "1.7",
    color: "#444",
  },

  contact: {
    padding: "60px 15px",
    background: "#d2d2d2",
    textAlign: "center",
  },

  form: {
    maxWidth: "400px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  input: { padding: "10px", fontSize: "14px" },

  textarea: { padding: "10px", minHeight: "90px" },

  submitButton: {
    padding: "12px",
    background: "#111",
    color: "white",
    border: "none",
  },

  whatsapp: {
    position: "fixed",
    bottom: "15px",
    right: "15px",
    background: "#000000",
    color: "white",
    padding: "12px 16px",
    borderRadius: "50px",
  },

  footer: {
    background: "#0f0f0f",
    color: "white",
    padding: "50px 20px 20px",
    marginTop: "60px",
  },

  footerGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "30px",
    maxWidth: "1100px",
    margin: "0 auto",
    textAlign: "right",
  },

  footerBox: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  footerLogo: {
    width: "120px",
    marginBottom: "10px",
  },

  footerBottom: {
    borderTop: "1px solid rgba(255,255,255,0.2)",
    marginTop: "30px",
    paddingTop: "15px",
    textAlign: "center",
    fontSize: "12px",
    opacity: 0.7,
  },

  hamburger: {
    fontSize: "28px",
    cursor: "pointer",
    color: "black",
    paddingRight: "10px", // 👈 מונע צמוד לקצה

  },

  mobileMenu: {
    background: "#111",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    gap: "20px",
    padding: "20px 0",

    position: "fixed",
    top: "70px",
    left: 0,

    width: "100%",   // 👈 קריטי
    maxWidth: "100vw", // 👈 מונע יציאה מהמסך

    zIndex: 999,
    animation: "slideDown 0.3s ease",
  },

  mobileLink: {
    color: "white",
    textDecoration: "none",
    fontSize: "20px",
  },
  accessButton: {
    position: "fixed",
    bottom: "80px",
    right: "15px",
    background: "#111",
    color: "white",
    border: "none",
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    fontSize: "22px",
    cursor: "pointer",
    zIndex: 1000,
  },

  accessPanel: {
    position: "fixed",
    bottom: "140px",
    right: "15px",
    background: "white",
    padding: "15px",
    borderRadius: "10px",
    boxShadow: "0 5px 20px rgba(0,0,0,0.3)",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    zIndex: 1000,
  },

  heroLogo: {
    width: "160px",
    marginBottom: "10px",
    borderRadius: "12px", // 👈 מרכך את הרקע הלבן
  },

  heroSub: {
    fontSize: "18px",
    opacity: 0.9,
  },

  management: {
    marginTop: "10px",
    fontSize: "13px",
    opacity: 0.7,
    lineHeight: "1.6",
  },
};

export default App;